import ReactDOM from 'react-dom';
import 'typeface-roboto';
import { App } from './App';
import './index.css';
import './megadraft.css';
import { maybeRedirectAzureCallback } from './utils/azureAuth';

maybeRedirectAzureCallback();

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
